import { User } from '@/shared/user';
import store from '@/store';
import { UserRoleRemoved } from '@/shared/events/user-role-removed';
import router from '@/router';
import userManager from '@/services/user-manager/user-manager';
import { Route } from 'vue-router';
import { snackbarProgrammatic } from '@/components/snackbar';

async function handleUserRoleRemoved(data: UserRoleRemoved): Promise<void> {
    const currentUser: User | null = store.getters['user/user'];

    // If the notification is not for the current user or was changed by the current user for themselves,
    // don't need to show.
    if (currentUser == null || data.aggregateId !== currentUser.id || data.userId === currentUser.id) {
        return;
    }

    await store.dispatch('user/loadMeAsync', data);

    // NOTE(Dan): Check if the user can still access the current route, if not send to their dashboard.
    const currentRoute = router.currentRoute;
    const routeCheck: (route: Route) => boolean = store.getters['user/hasPermissionForRoute'];

    snackbarProgrammatic.open({ message: `You have been assigned the '${data.role}' role.`, type: 'is-info' });

    await userManager.signinSilent();

    if (!routeCheck(currentRoute)) {
        router.push({ name: 'home' });
    }
}

export default handleUserRoleRemoved;
